import { useAppointmentReminders } from '../hooks/useAppointmentReminders';
import { useBigliettiAlerts } from '../hooks/useBigliettiAlerts';
import { useLeadReminders } from '../hooks/useLeadReminders';
import { useNewLeadAlerts } from '../hooks/useNewLeadAlerts';
import { useSubscriptionDraftAlerts } from '../hooks/useSubscriptionDraftAlerts';

export const ReminderListener = () => {
  useAppointmentReminders();
  useLeadReminders();
  useNewLeadAlerts();
  useSubscriptionDraftAlerts();
  useBigliettiAlerts();
  return null;
};

export default ReminderListener;
